<template>
<div>
  <div class="radio__label">   
	<div class="radio-group" v-if="!onlyMonthly">
		<div class="radio__part">
			<input id="oneTime" type="radio" class="frequency" :checked="type == 'single'" @click="setSingle"/>
			<FormLabel for="oneTime">One time</FormLabel>
		</div>
		<div class="radio__part" v-if="addMonthly">
			<input id="monthly" type="radio" class="frequency" :checked="type == 'monthly'" @click="setMonthly"/>
			<FormLabel for="monthly">Monthly</FormLabel>		
		</div>
		<div class="radio__part" v-if="addSplit">
			<input id="split" type="radio" class="frequency" :checked="type == 'split'" @click="setSplit"/>
			<FormLabel for="split">Split Payment</FormLabel>		
		</div>
	</div>
  <div class="monthly-note" v-if="type === 'split'">
    <select :value="duration" @change="e => setValue('periodMonths', e.target.value)">
      <option v-for="i in splitMonths" :key="i" :value="i">{{i}} {{i == 1 ? 'Month' : 'Months'}}</option>
    </select>
    <div v-if="splitAmount">
      {{splitAmount}}
    </div>
    <div v-else>
      Please select amount to split, and number of months
    </div>
  </div>
   </div>
	<div class="monthly-note"  v-if="type === 'monthly'">    
    <div>
      Your donation will be made today and on the <strong>{{monthDay}}</strong> of each following month using the payment method selected. You may change or cancel this amount at any time.
    </div>
  </div>
  <div class="selectdoantion__label"  v-if="type !== 'monthly'">Select donation frequency</div>
</div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  type PropType,
  ref,
  watch,
  onMounted
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

function round (number: number) {
  return Math.floor(number * 100) / 100
}
export default defineComponent({  props: {
    addSplit: {
      type: Boolean,
      default: false,
    },
    splitMonths: {
      type: Number,
      default: 12
    },
    addMonthly: {
      type: Boolean,
      default: false
    },
    onlyMonthly: {
      type: Boolean,
      default: false
    },
  },
  setup(props) {
    const { form, setValue } = usePaymentForm()

    const type = ref<'single' | 'monthly' | 'split'>('single')

    const splitAmount = computed(() => {
      if (!form.value.amount) return

      const recurringAmount = Math.round(Number(form.value.amount) / Number(form.value.periodMonths))
    
      const totalAmount = recurringAmount * +form.value.periodMonths!;

      var difference = Number(form.value.amount) - totalAmount;

      var initialAmount = recurringAmount + difference;

      if (initialAmount != recurringAmount) {
        return `One payment of ${form.value.currency == 'ILS'? '₪' : '$'}${initialAmount} and ${+form.value.periodMonths! - 1} payments of ${form.value.currency == 'ILS'? '₪' : '$'}${recurringAmount}`
      }
      else {
        return `${form.value.periodMonths} payments of ${form.value.currency == 'ILS'? '₪' : '$'}${recurringAmount}`
      }
    })

    onMounted(() => {
      if(props.onlyMonthly) {
        type.value = 'monthly'
        setValue('dayOfMonth', ''+new Date().getDate())
        setValue('periodMonths', null)
      } else if (form.value.dayOfMonth) {
        type.value = 'monthly'
      }
    })

    // Watch for changes in dayOfMonth to update the radio button state
    watch(() => form.value.dayOfMonth, (newValue) => {
      if (newValue) {
        type.value = 'monthly'
      } else if (type.value === 'monthly' && !props.onlyMonthly) {
        type.value = 'single'
      }
    })

    function setSingle() {
      type.value = 'single'
      setValue('dayOfMonth', null)
      setValue('periodMonths', null)
    }

    function setMonthly() {
      type.value = 'monthly'
      setValue('dayOfMonth', ''+new Date().getDate())
      setValue('periodMonths', null)
    }

    function setSplit() {
      type.value = 'split'
      setValue('dayOfMonth', null)
      setValue('periodMonths', '2')
    }
    
    return {
      duration: computed(() => form.value.periodMonths),
      setSplit,
      setSingle,
      setMonthly,
      setValue,
      type,
      splitAmount,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!

        const j = i % 10,
          k = i % 100
        if (j == 1 && k != 11) {
          return i + 'st'
        }
        if (j == 2 && k != 12) {
          return i + 'nd'
        }
        if (j == 3 && k != 13) {
          return i + 'rd'
        }
        return i + 'th'
      }),
    }
  },
})
</script>
<style scoped lang="scss">
.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;
  select {
    max-width: calc(22% - 10px);
    margin-right: 10px;
    min-width: 120px;
  } 
}

.radio__label{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    gap:14px;
    padding-top: 32px;
    padding-bottom: 12px;
        @media only screen and (max-width: 720px) {
    gap:0px;
    }
}
.radio-group{
  display: flex;
  background: #ffffff;
  border-radius: 6px;
}
.radio__part{
      input[type='radio'] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label{
font-weight: 500;
font-size: 14px;
line-height: 20px;
text-align: center;
vertical-align: middle;
cursor: pointer;
width: 128px;
height: 48px;
border-radius: 6px;
gap: 16px;
padding-top: 12px;
padding-right: 20px;
padding-bottom: 12px;
padding-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
      @media only screen and (max-width: 720px) {
font-weight: 500;
font-size: 14px;
line-height: 20px;
width: 100px;
height: 40px;
      }

      &:hover{
            background: #EBEBEB;
    }
  }
   input[type='radio']:checked + label {
    background: #F87507;
    color: white;
   }
}

.paymenttype__svg--mobile{
  display: flex;
        @media only screen and (min-width: 720px) {
     display: none;
    }
}

.paymenttype__svg{
    display: flex;
        @media only screen and (max-width: 720px) {
     display: none;
    }
}
.selectdoantion__label{
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
/* identical to box height, or 143% */
display: flex;
align-items: center;
color: #FFFFFF;
padding-bottom: 32px;
mix-blend-mode: normal;
text-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);

}
</style>